export default __webpack_public_path__ + "static/media/small_QOSMO-HEADER-OHNE-BAR-1440.2aeb00c1.mp4";